import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Toggle from './toggle'
import Input from '../input'
import Button from '../button/button'
import useLocalStorage from '../../hooks/useLocalStorage'
import { COLORS } from '../../utils/colors'
import Modal from '../modal'

const ContentBox = styled.div`
  text-align: left;

  label {
    text-align: right;
    width: 50%;
    display: inline-block;
  }

  @media only screen and (max-width: 600px) {
    input {
      max-width: 100px;
    }
  }
`

const UserBox = styled.div`
  margin-bottom: 15px;
  label {
    margin-right: 15px;
  }
`

const ColorBox = styled.div`
  margin-top: 22px;
  display: flex;
`

const Colors = styled.div`
  display: flex;
  margin-left: 15px;
  align-items: center;
  justify-content: space-between;
`

const Color = styled.div`
  border-radius: 100%;
  width: 17px;
  height: 17px;
  background-color: ${props => props.color};
  margin-right: 8px;
  cursor: pointer;
  transition: all 0.2s;
  ${props => props.selected && `
    border: 2px solid white;
  `}

  &:hover {
    transform: scale(1.2);
  }

  &:last-child {
    margin-right: 0;
  }
`

const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`

const Settings = ({ history }) => {
  const [settings, setSettings] = useLocalStorage('settings', {}, 0)
  const [nickname, setNickname] = useState(settings.nickname || '')
  const [check, setCheck] = useState(settings.check || false)
  const [color, setColor] = useState(settings.color || 'blue')
  const [timer, setTimer] = useState(settings.timer || false)

  const onClickSave = () => {
    setSettings({
      check,
      nickname,
      color,
      timer,
    })
    history.push('/')
  }


  return (
    <Modal
      title='Settings'
      onCloseLink='/'>
        <ContentBox>
        <UserBox>
          <label htmlFor='nickname'>Set nickname</label>
          <Input
            placeholder='eg. puzzler'
            value={nickname}
            onChange={e => setNickname(e.target.value)}
            title='An optional nickname to display in the game'
            name='nickname' />
        </UserBox>
        <Toggle
          label='Default check mode'
          title='Should check mode by enabled by default or not'
          value={check}
          onChange={e => setCheck(e.target.checked)} />
        <div style={{ marginTop: 16 }}>
          <Toggle
            label='Show timer'
            title='Should the timer be visible by default or not'
            value={timer}
            onChange={e => setTimer(e.target.checked)} />
        </div>
        <ColorBox>
          <label htmlFor='color'>Preferred color</label>
          <Colors>
            {COLORS.map(c => (
              <Color
                key={`color-${c}`}
                color={c}
                onClick={() => setColor(c)}
                selected={c === color} />
            ))}
          </Colors>
        </ColorBox>
        <ButtonBox>
          <Button text='Save' onClick={onClickSave} />
        </ButtonBox>
      </ContentBox>
    </Modal>
  )
}

export default Settings